module.exports = {
  CARDINAL_FIELD_ATTRIBUTE: 'data-cardinal-field',
  CONSUMER_SESSION_ID_KEY: 'cc.ConsumerSessionId',  
  FINGERPRINTED_TIMESTAMP: 'cc.FingerprintedTimestamp',
  URLS: {
    DEVICE_FINGERPRINTER:{      
      BIN_RENDER: '/Bin/Render',
      BROWSER_RENDER: '/Browser/Render'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./constants/generalSettings.js
// module id = 58
// module chunks = 5